import { ThemeProvider } from '@emotion/react';
import { createTheme, CssBaseline } from '@mui/material';
import BrowserApp from './BrowserApp/BrowserApp';
import MediaQuery from 'react-responsive';
import MobileApp from './MobileApp/MobileApp';
import StructureData from './components/StructureData/StructureData';


const myTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#1d6c3c',
    },
    secondary: {
      main: '#fff200',
    },
  },
});

const MOBILE_WIDTH = 1224

function App() {
  return (
    <div className='App'>
      <StructureData />
      <ThemeProvider theme={myTheme} >
        <CssBaseline />
        <MediaQuery minWidth={MOBILE_WIDTH}>
          <BrowserApp />
        </MediaQuery>
        <MediaQuery maxWidth={MOBILE_WIDTH}>
          <MobileApp />
        </MediaQuery>
      </ThemeProvider>  
    </div>
    
  );
}

export default App;

